import type { IApplicationInsights } from '@microsoft/applicationinsights-web';

import type { BlueConicClient } from './blueconic.types';
import type { Enum } from './enum.types';
import type { RoundPhase } from './match.types';

declare global {
  interface Window {
    D3: any;
    environment: string;
    thirdParties: boolean;
    webpack_public_path?: string;
    appInsights: IApplicationInsights;
    appInsightsConnectionString: string;
    appInsightsSamplingPercentage: number;
    apiKey: string;
    fspApiLimit: number;
    matchApiUrl: string;
    compApiUrl: string;
    pssApiUrl: string;
    compStatsApiUrl: string;
    standingsApiUrl: string;
    drawApiUrl: string;
    matchStatsApiUrl: string;
    bracketApiUrl: string;
    cardApiUrl: string;
    masApiUrl: string;
    domesticApiUrl: string;
    broadcasterApiUrl: string;
    uefaBaseUrl: string;
    uefaApiBaseUrl: string;
    imgBaseUrl: string;
    jwplayerScript: string;
    cobaltBaseUrl: string;
    cobaltApiUrl: string;
    cobaltApiKey: string;
    cobaltImgBaseUrl: string;
    sponsorApiUrl: string;
    sponsorPhase: string;
    performanceApiBaseUrl: string;
    gamingHubComponentUrl: string;
    competitionId: string;
    competitionCode: string;
    competitionFolder: string;
    competitionBanner: string;
    competitionTracking: string;
    competitionUrl: string;
    competitionName: string;
    videoAdvTag: string;
    videoAdsContext: string;
    bannerAdsContext: string;
    isClub: boolean;
    showTeamsDisclaimer: boolean;
    currentSeason: number;
    currentPhase: RoundPhase;
    idpScript?: string;
    idpApiKey?: string;
    skipInitIdpHandler?: boolean;
    jwplayer: JWPlayerStatic;
    twttr?: any;
    facebookAppId?: string;
    facebookClientSecret?: string;
    syncFavouritesNotification?: boolean;
    syncFollowedNotification?: boolean;
    savedFavouriteTeam?: any;
    impressionScrollThreshold?: number;
    impressionTimeThreshold?: number;
    storyTellerApiKey?: string;
    blueConicClient?: BlueConicClient;
    newTableFormat?: boolean;
    uefaTvApiUrl: string;
    uefaTvApiKey: string;
    uefaTvRealm: string;
  }
}

// http://wicg.github.io/netinfo/#dom-megabit
type Megabit = number;
// http://wicg.github.io/netinfo/#dom-millisecond
type Millisecond = number;
export const ConnectionType = {
  bluetooth: 'bluetooth',
  cellular: 'cellular',
  ethernet: 'ethernet',
  mixed: 'mixed',
  none: 'none',
  other: 'other',
  unknown: 'unknown',
  wifi: 'wifi',
  wimax: 'wimax',
} as const;
export type ConnectionType = Enum<typeof ConnectionType>;

export const EffectiveConnectionType = {
  '2g': '2g',
  '3g': '3g',
  '4g': '4g',
  'slow-2g': 'slow-2g',
} as const;
export type EffectiveConnectionType = Enum<typeof EffectiveConnectionType>;

export interface NetworkInformation extends EventTarget {
  // http://wicg.github.io/netinfo/#type-attribute
  readonly type?: ConnectionType;
  // http://wicg.github.io/netinfo/#effectivetype-attribute
  readonly effectiveType?: EffectiveConnectionType;
  // http://wicg.github.io/netinfo/#downlinkmax-attribute
  readonly downlinkMax?: Megabit;
  // http://wicg.github.io/netinfo/#downlink-attribute
  readonly downlink?: Megabit;
  // http://wicg.github.io/netinfo/#rtt-attribute
  readonly rtt?: Millisecond;
  // http://wicg.github.io/netinfo/#savedata-attribute
  readonly saveData?: boolean;
  // http://wicg.github.io/netinfo/#handling-changes-to-the-underlying-connection
  onchange?: EventListener;
}
